import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'//

import item from './modules/item'
import app from './modules/app'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    item,
    app,
  },
  // plugins: [createPersistedState({})]
})

export default store
